export const FETCH_STATUSES = {
  INIT: 'INIT',
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED'
};
